import baseAPI from '@/api/base';
import { InitiatePayrollBody } from '@/dtos/payroll.dto';
import {
  APPROVE_PAYROLL_URL,
  DELETE_PAYROLL_URL,
  EDIT_PAYROLL_URL,
  EXPORT_EMPLOYEE_PAYROLL_ETAX_URL,
  EXPORT_EMPLOYEE_PAYROLL_SLIP_PDF_URL,
  EXPORT_PAYROLL_BANK_REPORT_PDF_URL,
  EXPORT_PAYROLL_CSV_URL,
  EXPORT_PAYROLL_REPORT_URL,
  GENERATE_PAYROLL_URL,
  GET_EMPLOYEES_WITH_SALARY_URL,
  GET_EMPLOYEES_WITHOUT_SALARY_URL,
  GET_PAYROLL_ANALYTICS_URL,
  GET_PAYROLL_COMPENSATION_URL,
  GET_PAYROLL_EMPLOYEE_ANALYTICS_URL,
  GET_PAYROLL_DETAILS_URL,
  GET_PAYROLL_STATS_CAHRT_URL,
  REGISTER_PAYROLL_URL,
  TOGGLE_PAYROLL_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';
import PayrollPeriod from './payroll_period';
import { GetPayrollPeriod } from '@/dtos/payroll_period.dto';

class Payroll {
  static registerPayroll = async (
    initialtePayroll: InitiatePayrollBody
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_PAYROLL_URL, {
      ...initialtePayroll,
    });
    console.log('response', response);
    return response;
  };

  static generatePayroll = async (registerPayroll: Array<any>): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(GENERATE_PAYROLL_URL, {
      ...registerPayroll,
    });
    console.log('response', response);
    return response;
  };

  static approvePayroll = async (payload: any): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(`${APPROVE_PAYROLL_URL}/${payload.id}`);
    console.log('response', response);
    return response;
  };

  static getPayrollDetails = async (getPayrollPeriod: GetPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PAYROLL_DETAILS_URL, {
      params: getPayrollPeriod,
    });
    console.log('response', response);
    return response;
  };

  static getPayrollStatsChart = async (getPayrollPeriod: GetPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PAYROLL_STATS_CAHRT_URL, {
      params: getPayrollPeriod,
    });
    console.log('response', response);
    return response;
  };

  static exportPayrollCSV = async (getPayrollPeriod: GetPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(EXPORT_PAYROLL_CSV_URL, {
      params: getPayrollPeriod,
      responseType: 'blob',
    });
    console.log('response', response);
    return response;
  };

  static exportPayrollBankReportPDF = async (getPayrollPeriod: GetPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(EXPORT_PAYROLL_BANK_REPORT_PDF_URL, {
      params: getPayrollPeriod,
      responseType: 'blob',
    });
    console.log('response', response);
    return response;
  };

  static exportEmployeePayrollSlipPDF = async (getPayrollPeriod: GetPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(EXPORT_EMPLOYEE_PAYROLL_SLIP_PDF_URL, {
      params: getPayrollPeriod,
      responseType: 'blob',
    });
    console.log('response', response);
    return response;
  };

  static exportEmployeePayrollETax = async (getPayrollPeriod: GetPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(EXPORT_EMPLOYEE_PAYROLL_ETAX_URL, {
      params: getPayrollPeriod,
      responseType: 'blob',
    });
    console.log('response', response);
    return response;
  };

  static getEmployeesWithoutSalary = async (getPayrollPeriod: GetPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEES_WITHOUT_SALARY_URL, {
      params: getPayrollPeriod,
    });
    console.log('response', response);
    return response;
  };

  static getCompensationOverview = async (payload: { organizationId: string }): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PAYROLL_COMPENSATION_URL, {
      params: payload,
    });
    return response;
  };

  static getPayrollAnalytics = async (params: Record<string, any>): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PAYROLL_ANALYTICS_URL, { params });
    return response;
  };

  static getPayrollEmployeeAnalytics = async (params: Record<string, any>): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PAYROLL_EMPLOYEE_ANALYTICS_URL, { params });
    return response;
  };

  static exportPayrollReport = async (params: Record<string, any>): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(EXPORT_PAYROLL_REPORT_URL, { params, responseType: 'blob' });
    return response;
  };

  static getEmployeesWithSalary = async (getPayrollPeriod: GetPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEES_WITH_SALARY_URL, {
      params: getPayrollPeriod,
    });
    console.log('response', response);
    return response;
  };

  // static editPayroll = async (editPayroll: EditPayroll): Promise<AxiosResponse> => {
  //   const response: AxiosResponse = await baseAPI.put(EDIT_PAYROLL_URL, {
  //     ...editPayroll,
  //   });
  //   return response;
  // };

  // static togglePayrollIsActive = async (
  //   editPayroll: EditPayroll
  // ): Promise<AxiosResponse> => {
  //   const response: AxiosResponse = await baseAPI.patch(
  //     TOGGLE_PAYROLL_IS_ACTIVE_URL,
  //     {
  //       ...editPayroll,
  //     }
  //   );
  //   return response;
  // };

  static deletePayroll = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PAYROLL_URL}/${id}`
    );
    return response;
  };
}

export default Payroll;
